/*
 * ControlInfo keys defined for the Unit section, used by UnitService.
 */
export enum UnitControlInfoKey {
	EnabledVirtualCreditCards = 'EnabledVirtualCreditCards',
	HomeState = 'HomeState',
	State = 'State',
}
